/*
  Small values this browser remembers between visits: the ranch last worked in, the cached
  branding record (so sign-in never flashes the built-in defaults), the id of an imagery upload
  to resume. localStorage, not a database (ADR 0020): nothing here is a record of the ranch's,
  and every read and write tolerates storage being unavailable (a private window, blocked site
  data), in which case the value simply is not remembered.
*/
const PREFIX = 'tally4244:'

export function readLocal<T>(key: string): T | undefined {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    return raw === null ? undefined : (JSON.parse(raw) as T)
  } catch {
    return undefined
  }
}

export function writeLocal(key: string, value: unknown): void {
  try {
    if (value === null || value === undefined) localStorage.removeItem(PREFIX + key)
    else localStorage.setItem(PREFIX + key, JSON.stringify(value))
  } catch {
    // Storage unavailable: not remembered, nothing lost.
  }
}

/** Sign-out: forget everything this app remembered in this browser. */
export function clearLocal(): void {
  try {
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith(PREFIX)) localStorage.removeItem(key)
    }
  } catch {
    // Storage unavailable.
  }
}
